import React, {useContext} from 'react';
import {ControlledFormContext} from "../ControlledForm";
import {Utils} from "../../../logic/reusable/Utils";

function NumberInput(props: TextInputProps) {
    const {name, label, labelAbove} = props
    const {handleFormChange, formData} = useContext(ControlledFormContext)

    return (
        <div className={`atoms-inputs-number ${labelAbove ? "above" : ""}`}>
            {label ? <label htmlFor={name}>{label}</label> : null}
            <input className={label ? "no-label" : ""} name={name} type="number" value={Utils.dynamicKeyAccess(formData, name)} onChange={handleFormChange}/>
        </div>
    );
}

export default NumberInput;
